import {
  PaidOutlined,
  PeopleAltOutlined,
  StorefrontOutlined,
  SwapHorizOutlined,
} from "@mui/icons-material";
import {lazy} from "react";
import type {Page, PageGroup} from "router/types";
import {ROLE_ADMIN, ROLE_SUPER_ADMIN} from "utils/roles";

const ResellerClientsPage = lazy(
  () => import("pages/resellers/clients/ResellerClientsPage"),
);
const ResellerTransfersPage = lazy(
  () => import("pages/resellers/transfers/ResellerTransfersPage"),
);
const ResellerCommissionsPage = lazy(
  () => import("pages/resellers/commissions/ResellerCommissionsPage"),
);

const resellersRoutes: Array<Page | PageGroup> = [
  {
    segment: "resellers",
    title: "Resellers",
    Icon: StorefrontOutlined,
    roles: [ROLE_SUPER_ADMIN, ROLE_ADMIN],
    canAccess: user =>
      Boolean(user.is_reseller) || user.role === ROLE_SUPER_ADMIN,
    children: [
      {
        segment: "clients",
        title: "Reseller Clients",
        Icon: PeopleAltOutlined,
        Component: ResellerClientsPage,
      },
      {
        segment: "transfers",
        title: "Reseller Transfers",
        Icon: SwapHorizOutlined,
        Component: ResellerTransfersPage,
      },
      {
        segment: "commissions",
        title: "Reseller Commissions",
        Icon: PaidOutlined,
        Component: ResellerCommissionsPage,
      },
    ],
  },
];

export default resellersRoutes;
